export default {"src":"/_next/static/media/logo_mediawind_white.6afda045.svg","height":47,"width":78,"blurWidth":0,"blurHeight":0};